<template>
  <div class="json-mapper-component">
    <div class="content-wrapper">
      <input
        v-if="getApiVersion > 7"
        class="task-name-input"
        type="text"
        ref="labelInputRef"
        :class="{
          'invalid-input': isInvalidLabel,
        }"
        :value="value"
        @input="handleLabelInput"
        placeholder="Geben Sie einen Namen in für den neuen inhalt ein. "
        :disabled="!isUserHasAccess"
      />
      <div class="dropdown-lists">
        <div
          class="object-element-wrapper"
          v-for="(objectElement, objectIndex) in objectValues"
          :key="objectIndex"
        >
          <div class="left-content-form">
            <input
              type="text"
              v-model="objectElement.key"
              :class="{
                'invalid-input': objectElement.keyError,
              }"
              @input="onInputValue(objectElement.id, 'key')"
              :disabled="!isUserHasAccess"
            />
            <div v-if="getDropdownItems.length">
              <generalDropdown :disabled="!isUserHasAccess">
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="item in getDropdownItems"
                    :key="item.label"
                    @click="
                      onSelectInputElement('key', item.name, objectElement.id)
                    "
                  >
                    {{ item.name }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
            </div>
          </div>

          <div class="right-content-form">
            <input
              type="text"
              v-model="objectElement.value"
              :class="{
                'invalid-input': objectElement.valueError,
              }"
              @input="onInputValue(objectElement.id, 'value')"
              :disabled="!isUserHasAccess"
            />
            <div v-if="getDropdownItems.length">
              <generalDropdown :disabled="!isUserHasAccess">
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="item in getDropdownItems"
                    :key="item.label"
                    @click="
                      onSelectInputElement('value', item.name, objectElement.id)
                    "
                  >
                    {{ item.name }}
                  </b-dropdown-item>
                </template>
              </generalDropdown>
            </div>
            <div
              v-if="isUserHasAccess"
              @click="onRemoveObjectElement(objectIndex)"
              class="remove-element"
              :class="{ space: !getDropdownItems.length }"
            >
              <b-icon-x-circle-fill></b-icon-x-circle-fill>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalDropdown from '../core/general-dropdown.vue';
import {
  getInputPlaceholderList,
  getApiEndpointVersion,
  LATEST_FLOW_RUNNER_VERSION,
} from '@/utils/helpers.js';

export default {
  data() {
    return {
      isInvalidLabel: false,
    };
  },
  props: {
    task: {
      type: Object,
    },
    objectValues: {
      type: Array,
    },
    isUserHasAccess: {
      type: Boolean,
      required: false,
      default: true,
    },
    flowRunnerEndpoint: {
      type: String,
    },
    existLabelNameList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleLabelInput(event) {
      if (event && event?.target) {
        const labelValue = event.target?.value?.trim() || '';
        this.$emit('input', labelValue);
        this.isInvalidLabel =
          this.existLabelNameList.includes(labelValue) || !labelValue.length;
      }
    },
    onSelectInputElement(type, item, elementId) {
      const objectToUpdate = this.objectValues.find(
        (objectElement) => objectElement.id == elementId
      );
      if (item.includes(':')) {
        objectToUpdate[type] = `{${item}}`;
      } else {
        const selectedObject = this.getSelectedInput(item);

        objectToUpdate[type] = `{${selectedObject.name}}`;
      }
      this.onInputValue(elementId, type);
    },

    onRemoveObjectElement(index) {
      if (this.isUserHasAccess) {
        this.$emit('onRemoveObjectElement', index);
      }
    },

    getSelectedInput(item) {
      return this.task.input.find((input) => input.label === item);
    },

    getAllKeyNames(id) {
      return this.objectValues
        .filter((objectElement) => objectElement.id !== id)
        .map((objectElement) => objectElement.key);
    },

    isValidInput(inputValue) {
      const regex = /[,.;!?'"*` ]/g;
      return !regex.test(inputValue);
    },

    onInputValue(objectElementId, type) {
      if (type === 'key') {
        this.objectValues.forEach((obj) => {
          if (obj.key) {
            obj.keyError =
              this.getAllKeyNames(obj.id).includes(obj.key) ||
              !this.isValidInput(obj.key)
                ? true
                : false;
          } else if (!obj.key && obj.keyError && obj.id === objectElementId) {
            obj.keyError = false;
          }
        });
      } else if (type === 'value') {
        const onFocusObejctElement = this.objectValues.find(
          (obj) => obj.id === objectElementId
        );

        onFocusObejctElement.valueError =
          onFocusObejctElement.value &&
          !this.isValidInput(onFocusObejctElement.value);
      }
    },
  },
  computed: {
    getDropdownItems() {
      return getInputPlaceholderList(
        this.task.input,
        this.getApiVersion || LATEST_FLOW_RUNNER_VERSION
      );
    },
    getApiVersion() {
      return getApiEndpointVersion(this.flowRunnerEndpoint);
    },
  },
  components: {
    generalDropdown,
  },
};
</script>

<style scoped>
.json-mapper-component .content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 60px;
  max-width: 820px;
  margin: 0 auto;
}

.json-mapper-component .content-wrapper .dropdown-lists {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: calc(100dvh - 500px);
  overflow: auto;
}
.json-mapper-component .object-element-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 58px;
  max-width: max-content;
  margin: 0 auto;
}

.json-mapper-component .right-content-form,
.json-mapper-component .left-content-form {
  display: flex;
  align-items: center;
  max-width: max-content;
}

.json-mapper-component .content-wrapper input.task-name-input,
.json-mapper-component .right-content-form input,
.json-mapper-component .left-content-form input {
  border: 0.8px solid #dee3e9;
  font-family: 'Aktiv Grotesk';
  border-radius: 6px;
  font-size: 20px;
  padding: 0 15px;
  cursor: text;
  line-height: 36px;
  padding: 8px 30px;
  width: 269px;
  height: auto;
}

.json-mapper-component .left-content-form input,
.json-mapper-component .right-content-form input {
  padding: 2px 14px;
  outline: none;
  font-size: 14px;
  font-weight: 400;
}
.json-mapper-component .content-wrapper input.task-name-input {
  width: 100%;
  outline: none;
}

.json-mapper-component .content-wrapper input.task-name-input::placeholder {
  font-family: 'Aktiv Grotesk';
  font-weight: 400;
  letter-spacing: 0;
  color: #c2c2c2;
}

.json-mapper-component .content-wrapper input.task-name-input.invalid-input {
  background-color: #ffffff;
  outline: 2px solid #ff050578;
  outline-offset: -2px;
}

.json-mapper-component .remove-element {
  cursor: pointer;
  margin-left: 8px;
}

.json-mapper-component .remove-element:hover svg {
  fill: #333343;
}
.json-mapper-component .remove-element.space {
  margin-left: 13px;
}
.json-mapper-component .remove-element svg {
  width: 15px;
  height: 15px;
  color: #bbbbbb;
  opacity: 0;
}
.json-mapper-component .object-element-wrapper:hover svg {
  opacity: 1;
}
.json-mapper-component .object-element-wrapper svg:hover {
  color: unset;
}
.json-mapper-component .invalid-input {
  background-color: #ff050578;
}
.json-mapper-component ::v-deep .dropdown-menu {
  max-height: 280px;
}
.json-mapper-component ::v-deep .dropdown .dropdown-toggle {
  box-shadow: none;
}
</style>
